import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core';
import { AdminPerfilesComponent } from './admin-perfiles/admin-perfiles.component';
import { AdminTareasComponent } from './admin-tareas/admin-tareas.component';
import { AdminUsuariosComponent } from './admin-usuarios/admin-usuarios.component';

import { AdminReportesComponent } from './admin-reportes/admin-reportes.component';
import { AdminCatalogosComponent } from './admin-catalogos/admin-catalogos.component';
import { AuditoriaDatatableComponent } from '../auditoria/datatable/auditoria-datatable.component';
import { AdminPlanesComponent } from './admin-planes/admin-planes.component';
import { AdminSuscripcionesComponent } from './admin-planes/admin-suscripciones/admin-suscripciones.component';
import { AdminIndicadoresComponent } from './admin-indicadores/admin-indicadores.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
    {
        path: 'usuarios',
        component: AdminUsuariosComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'tareas',
        component: AdminTareasComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'perfiles',
        component: AdminPerfilesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'reportes',
        component: AdminReportesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'catalogos',
        component: AdminCatalogosComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'auditoria',
        component: AuditoriaDatatableComponent,
        canActivate: [AuthGuard],
        data: {
            roles: []
        },
    },
    {
        path: 'planes',
        component: AdminPlanesComponent,
        canActivate: [AuthGuard],
        data: {
            roles: []
        },
    },
    {
        path: 'planesorganizacion',
        component: AdminSuscripcionesComponent,
        canActivate: [AuthGuard],
        data: {
            roles: []
        },
    },
    {
        path: 'indicadores',
        component: AdminIndicadoresComponent,
        canActivate: [AuthGuard],
        data: {
            roles: []
        },
    },  
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdministracionRoutingModule { }